import {default as fire} from "../firebase";

export default fire 



